<template>
<v-layout align-center justify-center row fill-height>
    <v-card>
        <v-card-title>
            <span>Login Error</span>
        </v-card-title>
        <v-card-text>
            <span>There was a problem logging you in. Please try again shortly.</span>
        </v-card-text>
        <v-btn @click="retry()">
            Retry
        </v-btn> 
        <v-btn @click="signOut()">
            Logout
        </v-btn> 
    </v-card>
</v-layout>
</template>

<script>
export default {
    components: {

    },
    methods: {
        retry() {
            this.$router.push({
                path: "/loggingin"
            })
        },
        signOut () {
            this.$router.push({
                path: "/logout"
            });
        }
    }
};
</script>